/* eslint-disable no-lonely-if */
/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */

import SessionService from '../services/SessionService';
import { CookieHelper } from './CookieHelper';
import { HostProvider } from './HostProvider';
import { StorageHelper } from './StorageHelper';

type TokenRenewedHandler = (token: string) => void;
type BootstrapSessionCheck = {
  view: string;
};

let bootstrapSessionCheck: BootstrapSessionCheck | null = null;

export class SessionChecker {
  static checkSession = async (
    view: string,
    lang: string,
    isApp: boolean,
    isRecuerdame?: boolean | false,
    onTokenRenewed?: TokenRenewedHandler,
    isInitialBootstrap = false,
  ) => {
    StorageHelper.setLogout(false);
    if (!isInitialBootstrap && bootstrapSessionCheck) {
      const isSameView = bootstrapSessionCheck.view === view;
      bootstrapSessionCheck = null;
      if (isSameView) return true;
    }
    if (!isApp && isRecuerdame !== undefined) {
      const response = await SessionService.checkSession(view);
      const { pojo } = response.data;
      if (response.data.error === false) {
        const renewedToken = pojo.token;
        if (renewedToken) {
          CookieHelper.renewToken(renewedToken, isRecuerdame);
          if (onTokenRenewed) onTokenRenewed(renewedToken);
        } else {
          StorageHelper.setLogout(true);
          if (pojo.login) {
            SessionChecker.closeSessionAndGoToLogin(view, lang);
          } else if (pojo.reLogin) {
            SessionChecker.closeSessionAndGoToReLogin(view, lang);
          } else if (pojo.needsRedirect) {
            document.location.href = `${HostProvider.getHost()}${lang}/${
              pojo.urRedirection
            }`;
          }
        }
        if (pojo.login || pojo.reLogin || pojo.needsRedirect) {
          StorageHelper.setLogout(true);
          return false;
        }
      } else {
        if (response.data.errorCode === 1) {
          StorageHelper.setLogout(true);
          SessionChecker.closeSessionAndGoToLogin(view, lang);
        } else {
          if (response.data.errorCode === 100) {
            StorageHelper.setLogout(true);
            SessionChecker.closeSessionAndGoToReLogin(view, lang);
          }
        }
        StorageHelper.setLogout(true);
        return false;
      }
      if (isInitialBootstrap)
        SessionChecker.rememberBootstrapSessionCheck(view);
      return true;
    }
    if (isApp) {
      if (isInitialBootstrap)
        SessionChecker.rememberBootstrapSessionCheck(view);
      return true;
    }
    StorageHelper.setLogout(true);
    return false;
  };

  private static rememberBootstrapSessionCheck = (view: string) => {
    bootstrapSessionCheck = { view };
  };

  static closeSessionAndGoToLogin = (view: string | null, lang: string) => {
    const origin = StorageHelper.getOrigin();
    const viewForBack = view && true && view !== 'null' ? view : origin;
    SessionChecker.closeSesion(origin);
    if (viewForBack) {
      document.location.href = `${HostProvider.getHost()}${lang}/logout?apToLogin=true&fromUrl=${viewForBack}`;
    } else {
      document.location.href = `${HostProvider.getHost()}${lang}/logout?apToLogin=true`;
    }
  };

  static closeSessionAndGoToReLogin = (view: string | null, lang: string) => {
    const origin = StorageHelper.getOrigin();
    const viewForBack = view && true && view !== 'null' ? view : origin;
    SessionChecker.closeSesion(origin);
    if (viewForBack) {
      document.location.href = `${HostProvider.getHost()}${lang}/logout?apToRelogin=true&fromUrl=${viewForBack}`;
    } else {
      document.location.href = `${HostProvider.getHost()}${lang}/logout?apToRelogin=true`;
    }
  };

  static closeSesion = (origin: string | null) => {
    const modal = document.querySelector('#modal-error[tabindex="0"]');
    if (modal) {
      modal.classList.remove('is-active');
    }
    StorageHelper.deleteUserFromSession();
    CookieHelper.removeUserCookiesForLogout();
    sessionStorage.clear();
    if (origin) {
      StorageHelper.setOrigin(origin);
    }
  };
}
/* eslint-enable import/no-cycle */
